import { useCallback, useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { Alert, Badge, Button, Card, Space, Statistic, Table, Typography } from "antd";
import { EyeOutlined, SyncOutlined } from "@ant-design/icons";
import { Col, Container, Row } from "react-bootstrap";
import { GetVisits } from "../services/ApiService";

const { Text, Title } = Typography;

function Visits() {
  const auth = useAuth();
  const token = auth.user.id_token;

  const [visits, setVisits] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchVisits = useCallback(async () => {
    setLoading(true);
    try {
      const result = await GetVisits(token);
      setTotal(result.total);
      setVisits(result.visits);
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchVisits();
  }, [fetchVisits]);

  const columns = [
    {
      title: "User",
      dataIndex: "email",
      key: "email",
      render: (email) => <Text>{email}</Text>,
    },
    {
      title: "Time",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (ts) => <Text type="secondary">{new Date(ts).toLocaleString()}</Text>,
    },
  ];

  const dataSource = visits.map((v, i) => ({ key: i, ...v }));

  return (
    <Container fluid>
      <Row className="mb-4 mt-3">
        <Col>
          <Title level={3}>Visit Statistics</Title>
        </Col>
      </Row>

      {error && (
        <Row className="mb-3">
          <Col>
            <Alert type="error" message={error} showIcon />
          </Col>
        </Row>
      )}

      <Row className="mb-4">
        <Col lg={3}>
          <Card>
            <Statistic
              title="Total Visits"
              value={total}
              prefix={<EyeOutlined />}
              loading={loading}
            />
          </Card>
        </Col>
        <Col lg={3}>
          <Card>
            <Statistic
              title="Unique Users"
              value={new Set(visits.map((v) => v.email)).size}
              loading={loading}
            />
          </Card>
        </Col>
      </Row>

      <Row>
        <Col lg={8}>
          <Card
            title={
              <Space>
                <Title level={4} style={{ margin: 0 }}>Visit Log</Title>
                {!loading && <Badge count={total} showZero color="blue" />}
              </Space>
            }
            extra={
              <Button icon={<SyncOutlined />} size="small" onClick={fetchVisits} loading={loading}>
                Refresh
              </Button>
            }
          >
            <Table
              dataSource={dataSource}
              columns={columns}
              loading={loading}
              pagination={{ pageSize: 20, hideOnSinglePage: true }}
              size="small"
            />
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Visits;
